<app-code-reader-base>
  <div class="relative size-full overflow-hidden rounded-lg bg-neutral-800">
    <div #target></div>
  </div>
  <!-- Overlay -->
  <div class="absolute top-0 left-0 flex size-full flex-col items-center justify-center gap-10">
    <!-- Barcode preview -->
    <div class="h-[338px] w-[800px] rounded-xl border-8 border-dashed border-white">
      <img class="size-full rounded-md object-cover opacity-30" src="assets/woordkr8/sprites/barcode-preview.png" />
    </div>
  </div>
  <!-- back button -->
  <button (click)="stopBarcodeScanner()" class="absolute top-0 left-4 w-48 transition-transform hover:scale-105" type="button">
    <img src="assets\woordkr8\sprites\back-button.png" class="object-contain" alt="Terug" />
  </button>
</app-code-reader-base>
